export default __webpack_public_path__ + "static/media/dog-deal-with-it.33793603.gif";